// MatchForm.jsx
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import OpponentModal from './OpponentModal';
import styles from './matchForm.module.css';
import stylesDefault from '../default.module.css';

export default function MatchForm({ match, onSuccess }) {
    const { register, handleSubmit, setValue, reset } = useForm();
    const [opponents, setOpponents] = useState([]);
    const [tusTeams, setTusTeams] = useState([]);
    const [_, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);

    const isEdit = !!match;

    useEffect(() => {
        if (!match) {
            reset(); // <-- clear form when match becomes null (e.g. after cancel)
            return;
        }
        if (match) {
            const cleanedMatch = { ...match };

            if (match.date) {
                const localDate = new Date(match.date);
                cleanedMatch.date = localDate
                    .toLocaleDateString('en-CA'); // YYYY-MM-DD
            }

            Object.entries(cleanedMatch).forEach(([key, value]) => setValue(key, value));
        }
    }, [match, setValue, reset]);

    useEffect(() => {
        fetchOpponents();
    }, []);

    const fetchOpponents = async () => {
        const res = await axios.get('/api/opponents/get_all_opponents');
        setOpponents(res.data);
    };
    useEffect(() => {
        const fetchTusTeams = async () => {
            const res = await axios.get('/api/matches/get_all_tus_teams'); // Add this API if missing
            setTusTeams(res.data);
        };
        fetchTusTeams();
    }, []);

    const onSubmit = async (data) => {
        if (isEdit) {
            await axios.put(`/api/matches/${match.id}`, data);
        } else {
            await axios.post('/api/matches', data);
        }
        reset();
        onSuccess();
    };

    return (
        <div className={styles.matchForm}>
            <form onSubmit={handleSubmit(onSubmit)} className={styles.formGrid}>
                <div className={styles.formRow}>
                    <label>
                        TuS-Team
                        <select {...register('tus_team')} required>
                            <option value="">Bitte wählen</option>
                            {tusTeams.map((team) => (
                                <option key={team.team} value={team.team}>
                                    {team.team}
                                </option>
                            ))}
                        </select>
                    </label>
                    <div className={styles.time}>
                        <label>
                            Datum
                            <input type="date" {...register('date')} required />
                        </label>
                        <label>
                            Uhrzeit
                            <input type="time" {...register('time')} required />
                        </label>
                    </div>
                    <label>
                        Heimspiel?
                        <select {...register('is_home')} required>
                            <option value={1}>Heim</option>
                            <option value={0}>Gast</option>
                        </select>
                    </label>
                </div>
                <div className={styles.formRow}>
                    <div className={styles.opponent}>
                        <label>
                            Gegner
                            <input
                                list="opponent-options"
                                placeholder="Gegner eingeben oder wählen"
                                {...register('opponent', { required: true })}
                            />
                        </label>

                        <datalist id="opponent-options">
                            {opponents.map((op) => (
                                <option key={op.team} value={op.team} />
                            ))}
                        </datalist>
                        <label>
                            Team
                            <select {...register('opponent_team_specification')}>
                                <option value="">I</option>
                                <option value="II">II</option>
                                <option value="III">III</option>
                                <option value="IV">IV</option>
                                <option value="V">V</option>
                            </select>
                        </label>
                    </div>
                    <div className={styles.goals}>
                        <label>
                            Tore TuS
                            <input type="number" {...register('tus_goals')} min="0" max="30" />
                        </label>

                        <label>
                            Tore Gegner
                            <input type="number" {...register('opponent_goals')} min="0" max="30" />
                        </label>
                    </div>
                </div>





                <button type="button" className={styles.linkButton} onClick={() => setShowModal(true)}>
                    + Gegner hinzufügen
                </button>

                <div className={styles.formButtons}>
                    <button className={stylesDefault.blueButton} type="submit">
                        {isEdit ? 'Spiel aktualisieren' : 'Spiele hinzufügen'}
                    </button>
                    <button className={stylesDefault.redButton} type="button" onClick={() => { reset(); onSuccess(); }}>
                        {'Abbrechen'}
                    </button>
                </div>
            </form>

            {showModal && (
                <OpponentModal
                    onClose={() => setShowModal(false)}
                    onAdd={(newOpponent) => {
                        setSearchTerm(newOpponent.team);
                        fetchOpponents(newOpponent.team);
                        setShowModal(false);
                    }}
                />
            )}
        </div>
    );
}
